var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"d":"M432 64l-240 240-112-112-80 80 192 192 320-320z","key":1})]);
}

IconCheckmark.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
